export default {
  spacing: (factor: number) => `${0.35 * factor}rem`
}
